import React from 'react';
import styled, { keyframes } from 'styled-components';

interface FireworkConfig {
  x: number;
  y: number;
  color: string;
}

const configs: FireworkConfig[] = [];
for (let i = 0; i < 80; i++) {
  const r = Math.sqrt(Math.random());
  const theta = Math.random() * 6.28;
  configs.push({
    x: Math.floor(r * Math.cos(theta) * 50) + 50,
    y: Math.floor(r * Math.sin(theta) * 50) + 50,
    color: `var(--fw-color${(i % 6) + 1})`
  });
}

const Fireworks = () => {
  return <Container>
    <Firework/>
    <Firework/>
    <Firework/>
    <Firework/>
    <Firework/>
    <Firework/>
  </Container>;
};

const FireworkAnimation = keyframes`
  0% { transform: translate(var(--fw-x), var(--fw-initialY)); width: var(--fw-initialSize); opacity: 1; }
  50% { width: var(--fw-initialSize); }
  75% { opacity: 1; }
  100% { width: var(--fw-finalSize); opacity: 0; }
`;

const Container = styled.div`
  width: 100%;
  height: 100%;
  background: linear-gradient(var(--shine-bg-color), #0000), #123;
  background-color: var(--shine-secondary-bg-color);
`;

const randomWithinSector = (sector: number) => {
  return Math.floor((Math.random() * 20) + (20 * sector));
}

const randomDelay = () => {
  return Math.floor(Math.random() * -60) / 10;
}

const Firework = styled.div`
  &
  {
    --fw-initialSize: calc(max(1vmin, 10px));
    --fw-finalSize: 45vmin;
    --fw-particleSize: calc(max(1vmin, 10px) / 4);
    --fw-y: -30vmin;
    --fw-x: -50%;
    --fw-initialY: 60vmin;
    content: "";
    animation: ${FireworkAnimation} 6s infinite;
    position: absolute;
    transform: translate(-50%, var(--fw-y));
    width: var(--fw-initialSize);
    aspect-ratio: 1;
    background: ${
      configs.map((config) => `radial-gradient(circle, ${config.color} var(--fw-particleSize), #0000 0) ${config.x}% ${config.y}%`).join(',')
    };
    background-size: var(--fw-initialSize) var(--fw-initialSize);
    background-repeat: no-repeat;
  }

  &:nth-child(3n) {
    --fw-color1: yellow;
    --fw-color2: khaki;
    --fw-color3: white;
    --fw-color4: lime;
    --fw-color5: gold;
    --fw-color6: mediumseagreen;
  }
  
  &:nth-child(3n+1) {
    --fw-x: 30vmin;
    --fw-y: -50vmin;
  }

  &:nth-child(3n+1),
  &:nth-child(3n+1)::before,
  &:nth-child(3n+1)::after {
    --fw-color1: pink;
    --fw-color2: violet;
    --fw-color3: fuchsia;
    --fw-color4: orchid;
    --fw-color5: plum;
    --fw-color6: lavender;
    --fw-finalSize: 40vmin;
  }

  &:nth-child(3n+2) {
    --fw-x: -30vmin;
    --fw-y: -50vmin;
  }

  &:nth-child(3n+2),
  &:nth-child(3n+2)::before,
  &:nth-child(3n+2)::after {
    --fw-color1: cyan;
    --fw-color2: lightcyan;
    --fw-color3: lightblue;
    --fw-color4: PaleTurquoise;
    --fw-color5: SkyBlue;
    --fw-color6: lavender;
    --fw-finalSize: 35vmin;
  }
  
  &:nth-child(1) {
    left: ${randomWithinSector(.5)}%;
    top: ${randomWithinSector(2)}%;
    animation-delay: ${randomDelay()}s;
  }
  
  &:nth-child(2) {
    left: ${randomWithinSector(.5)}%;
    top: ${randomWithinSector(3)}%;
    animation-delay: ${randomDelay()}s;
  }

  &:nth-child(3) {
    left: ${randomWithinSector(.5)}%;
    top: ${randomWithinSector(4)}%;
    animation-delay: ${randomDelay()}s;
  }

  &:nth-child(4) {
    left: ${randomWithinSector(3.5)}%;
    top: ${randomWithinSector(2)}%;
    animation-delay: ${randomDelay()}s;
  }

  &:nth-child(5) {
    left: ${randomWithinSector(3.5)}%;
    top: ${randomWithinSector(3)}%;
    animation-delay: ${randomDelay()}s;
  }

  &:nth-child(6) {
    left: ${randomWithinSector(3.5)}%;
    top: ${randomWithinSector(4)}%;
    animation-delay: ${randomDelay()}s;
  }
`;

export default Fireworks;
